var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-xs-center my-4"},[_vm._v("\n  Bạn không có quyền truy cập\n")])}
var staticRenderFns = []

export { render, staticRenderFns }